$(document).ready(function(){
    Elevatione.init()
})

Elevatione.addToCartSuccess = function () {
    $.getJSON('/cart.js', function(cart) { 
        $(".num_count").each(function(){
            $(this).html(cart.item_count);
        });
    });
    Elevatione.goToCart()
}

Elevatione.preAddToCart = function (that) {
    $('button').attr('disabled', true)
    $(that).find('span').css({'visibility': "hidden"});
    $(that).find('.load-3p').css({"display": "inline"});
}


Elevatione.addDiscountedProduct = function () {
    Elevatione.addToCart(Elevatione.DISCOUNTEDPRODUCT_ID, 1, {}, Elevatione.addToCartSuccess)
}

Elevatione.addRapidDiscountedProduct = function () {
    Elevatione.addToCart(Elevatione.DISCOUNTEDPRODUCT_ID, 1, {}, Elevatione.rapidCheckout)
}


Elevatione.init = function () {

    $('.js-product-form__cart-submit, .js-product-different-form__cart-submit').on('click', function() {
        Elevatione.preAddToCart(this)
        let discountedCallback = Elevatione.dynamicCheckout == 2 ? Elevatione.addRapidDiscountedProduct : Elevatione.addDiscountedProduct
        let successCallback = Elevatione.dynamicCheckout == 2 ? Elevatione.rapidCheckout : Elevatione.addToCartSuccess
        $form = $(this).closest('form')
        Elevatione.addToCartForm(
            $form.serialize(),
            Elevatione.DISCOUNTEDPRODUCT_ID ? discountedCallback : successCallback
        )
    })

    $('.js-product-form__checkout-submit, .js-product-different-form__checkout-submit').on('click', function() {
        Elevatione.preAddToCart(this)
        $form = $(this).closest('form')
        Elevatione.addToCartForm(
            $form.serialize(),
            Elevatione.DISCOUNTEDPRODUCT_ID ? Elevatione.addRapidDiscountedProduct : Elevatione.rapidCheckout
        )
    })

    Elevatione.initializeLoanProviders()

    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop(); 
        $('#satcb_bar').toggleClass('sticky_add_cart', scroll >= $('#product-recommendation').offset().top);
        $('.bags-image-container-mobile .single-image-container-outer:visible:not(:eq(0))').css({"display":"none"});
        if ( $(window).width() < 1024 ) {
            //console.log(scroll >= ($('section.footer-section').offset().top - $('section.footer-section').height()))
            if (scroll >= ($('section.footer-section').offset().top - $('section.footer-section').height())){
                $(".product-form__controls-group1").removeClass("product-form__controls-group");
                $(".product-form__controls-group").fadeOut()
            } else if (scroll >= 328) {
                $(".product-form__controls-group1").addClass("product-form__controls-group");
            } else {
                $(".product-form__controls-group1").removeClass("product-form__controls-group");
            }
        }
    });
}

Elevatione.allowedLoanProviders = function () {
    Elevatione.ipLocation = Elevatione.detectLocation()
    // Elevatione.ipLocation.country_code = 'US'

    if (Elevatione.ipLocation.country_code == 'US' && (Elevatione.product.price / 100) < 600) {
        let rotate = JSON.parse(sessionStorage.getItem('allowedLoanProviders') || '["affirm", "afterpay"]')
        rotate = rotate[0] == 'affirm' ? ["afterpay"] : ["affirm"]
        sessionStorage.setItem('allowedLoanProviders', JSON.stringify(rotate))
        return rotate
    } else if (Elevatione.ipLocation.country_code == 'US' && (Elevatione.product.price / 100) >= 600) {
        return ["affirm"]
    }
    return ['splitt']
}

Elevatione.initializeLoanProviders = function () {
    if (Elevatione.product.is_subscription) {
        $('#loan-providers').remove()
        return false;
    }

    $('#default-prod-price-para').remove()

    for (let i = 0; i < Elevatione.loanProviders.length; i++) {
        if (Elevatione.loanProviders[i] == 'affirm') {
            let affirmhtml = '<div class="loan-providers-single col-sm-7" id="affirm-payment">'
            affirmhtml += '<p class="affirm-as-low-as roboto-regular affirm-para" data-page-type="product" data-amount="' + (Elevatione.product.price ) + '"></p>'
            affirmhtml += '</div>'
            $('#loan-providers').append(affirmhtml)
            setTimeout( function () {
                Elevatione.initializeAffirm()
                setTimeout(function () {
                    $('.affirm-ala-price').html(Shopify.format_money(parseInt($('.affirm-ala-price').html().replace('$','')) * 100, theme.moneyFormat))
                })
            })
        }
        if (Elevatione.loanProviders[i] == 'afterpay') {
            let afterpay = '<div class="loan-providers-single col-sm-7"><div id="afterpay-payment"></div></div>'
            $('#loan-providers').append(afterpay)
            setTimeout( function () {
                Afterpay.init($)
            })
        }
        if (Elevatione.loanProviders[i] == 'splitt') {
            Elevatione.calculateprice()
        }
    }
    if (!Elevatione.loanProviders.includes('splitt')) {
        $('.splitit-dynamic-container').remove()
    }
    if (!Elevatione.loanProviders.includes('afterpay')) {
        $('.afterpay-payment-container').remove()   
    }
    if (Elevatione.loanProviders.length == 1) {
        $('.loan-providers-single').removeClass('col-sm-4')
        $('.loan-providers-single').addClass('col-sm-4');
        $('.splitit-dynamic-container').addClass('col-sm-7');
    }
}

Elevatione.calculateprice = function () {
    let dataprice = parseInt($('.price-content').attr('data-price'));
    let calculatedprice = parseInt(dataprice/100);
    let emi_installment = parseInt($('.emi_id').attr('data-emi'));
    let calculatedtotalprice = (parseFloat(calculatedprice/emi_installment)).toFixed(2);
    $('.price-content').html(Shopify.format_money(calculatedtotalprice, Elevatione.currency_format))
}


Elevatione.initializeAffirm = function () {
    let _affirm_config = {
        public_api_key:  "AVOFSDUHU65AP4IU",
        script:          "https://cdn1.affirm.com/js/v2/affirm.js",
        session_id:      "YOUR_VISITOR_SESSION_ID"
    };
    (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");
    // Use your live public API Key and https://cdn1.affirm.com/js/v2/affirm.js script to point to Affirm production environment.
}
